if (!HTMLCanvasElement.prototype.toBlob) {
  Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
    value: function(callback, type, quality) {
      var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
        len = binStr.length,
        arr = new Uint8Array(len)

      for (var i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i)
      }

      callback(new Blob([arr], { type: type || 'image/png' }))
    }
  })
}

// --- File ---
/**
 * File を ArrayBuffer として読み込み Blob に変換
 */
export const fileToBlob = (file: File): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => {
      const result = reader.result ? reader.result : ''
      resolve(new Blob([result], { type: file.type }))
    }
    reader.onerror = reject
    reader.readAsArrayBuffer(file)
  })
}

/**
 * Blob を Base64 エンコード
 */
export const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve, reject) => {
    let fr = new FileReader()
    fr.onload = event => {
      resolve(event.target['result'])
    }
    fr.onerror = reject
    fr.readAsDataURL(blob)
  })
}

/**
 * EXIF 情報から画像の orientation を取得する
 */
export const blobToOrientation = (blob: Blob): Promise<number> => {
  return new Promise(async resolve => {
    const base64 = await blobToBase64(blob)
    const byteStr = atob(base64.split(',')[1])
    const orientation = await byteStringToOrientation(byteStr)
    resolve(orientation)
  })
}

/**
 * EXIF 情報を元に画像の回転を直す
 */
export const clearOrientation = (imgDataURL: string): Promise<string> => {
  return new Promise(async resolve => {
    const byteString = window.atob(imgDataURL.split(',')[1])
    const orientaion = byteStringToOrientation(byteString)

    let img = await loadImage({ src: imgDataURL })
    let canvas = document.createElement('canvas')
    let ctx = canvas.getContext('2d')
    switch (orientaion) {
      case 3: // 画像が180度回転している時
        canvas.width = img.width
        canvas.height = img.height
        ctx.rotate(Math.PI)
        ctx.drawImage(img, -img.width, -img.height)
        ctx.rotate(-Math.PI)
        break
      case 6: // 画像が時計回りに90度回っている時
        canvas.width = img.height
        canvas.height = img.width
        ctx.rotate(Math.PI * 0.5)
        ctx.drawImage(img, 0, -img.height)
        ctx.rotate(-Math.PI * 0.5)
        break
      case 8: // 画像が反時計回りに90度回っている時
        canvas.width = img.height
        canvas.height = img.width
        ctx.rotate(-Math.PI * 0.5)
        ctx.drawImage(img, -img.width, 0)
        ctx.rotate(Math.PI * 0.5)
        break
      default:
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
    }
    resolve(canvas.toDataURL('image/jpeg'))
  })
}

/**
 * EXIF 情報の orientation を取得
 */
export const byteStringToOrientation = (imgStr: string): number => {
  let head = 0
  let orientation
  while (head <= imgStr.length) {
    if (imgStr.charCodeAt(head) === 255 && imgStr.charCodeAt(head + 1) === 218) {
      break
    }
    if (imgStr.charCodeAt(head) === 255 && imgStr.charCodeAt(head + 1) === 216) {
      head += 2
    } else {
      const length = imgStr.charCodeAt(head + 2) * 256 + imgStr.charCodeAt(head + 3)
      const endPoint = head + length + 2
      if (imgStr.charCodeAt(head) === 255 && imgStr.charCodeAt(head + 1) === 225) {
        const segment = imgStr.slice(head, endPoint)
        const bigEndian = segment.charCodeAt(10) === 77
        const count = bigEndian
          ? segment.charCodeAt(18) * 256 + segment.charCodeAt(19)
          : segment.charCodeAt(18) + segment.charCodeAt(19) * 256
        for (let i = 0; i < count; i++) {
          const field = segment.slice(20 + 12 * i, 32 + 12 * i)
          if (
            (bigEndian && field.charCodeAt(1) === 18) ||
            (!bigEndian && field.charCodeAt(0) === 18)
          ) {
            orientation = bigEndian ? field.charCodeAt(9) : field.charCodeAt(8)
          }
        }
        break
      }
      head = endPoint
    }
  }
  return orientation
}

// --- HTMLCanvasElement ---
/**
 * canvas を Blob に変換する
 */
export const canvasToBlob = (canvas: HTMLCanvasElement, quality: number = 1.0): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const type = 'image/jpeg'
    // if (canvas.toBlob) {
    canvas.toBlob(
      blob => {
        resolve(blob)
      },
      type,
      quality
    )
  })
}

// -- HTMLImageElement ---
/**
 * 画像の読み込み
 */
export const loadImage = (options: LoadImageOptions): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    if (options.cors) {
      img.crossOrigin = 'anonymous'
    }
    img.onload = () => {
      resolve(img)
    }
    img.onerror = reject
    img.src = options.src
  })
}

interface LoadImageOptions {
  src: string
  cors?: boolean
}
